<template>
  <div>
    <span class="role-table" v-if="customer">
      {{ formatUserType(customer.type) }}
    </span>
    <a
      v-if="customer !== null"
      class="text-capitalize hide-data"
      :href="redirectTo(customer._id, customer.type)"
      target="_blank"
    >
      {{ getCustomerName(customer) }}
    </a>
    <span v-else class="text-danger text-capitalize">Unassigned</span>
  </div>
</template>

<script>
export default {
  name: "ShowCustomer",
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  methods: {
    getCustomerName(customer) {
      if (!customer) return "Unassigned";
      if (customer.company_name) {
        return customer.company_name;
      } else {
        return `${customer.first_name} ${customer.last_name}`;
      }
    },
    redirectTo(customerId, customerType) {
      if (customerType === "travel_agency") {
        return `/partners/${customerId}`;
      } else {
        return `/customers/${customerId}`;
      }
    },
    formatUserType(type) {
      if (type === "admin") {
        return "Admin";
      } else if (type === "driver") {
        return "Driver";
      } else if (type === "suppliers") {
        return "Supplier";
      } else if (type === "customer") {
        return "Customer";
      } else if (type === "ote") {
        return "OTE";
      } else if (type === "travel_agency") {
        return "Travel Agency";
      } else if (type === "travel_access") {
        return "Agent";
      } else if (type === "business") {
        return "Business";
      } else if (type === "guest") {
        return "Guest";
      }
      return "Client";
    }
  }
};
</script>
